var components
try {
  components = {
    uIcon: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-icon/u-icon" */ "uview-ui/components/u-icon/u-icon.vue"
      )
    },
    uPopup: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-popup/u-popup" */ "uview-ui/components/u-popup/u-popup.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = (_vm.shop.integral || 0).toFixed(0)
  var g1 = _vm.showMoney ? (_vm.countData.saleTotalNum || 0).toFixed(0) : null
  var g2 = _vm.showMoney ? (_vm.countData.profitTotalNum || 0).toFixed(0) : null
  var l1 =
    !_vm.show && !_vm.showQrcode && !_vm.showHaibao
      ? _vm.__map(_vm.dataList, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var l0 = _vm.__map(
            item.goodsorderDetailList || [],
            function (item1, index1) {
              var $orig = _vm.__get_orig(item1)
              var g3 = (item1.price || 0).toFixed(2)
              return {
                $orig: $orig,
                g3: g3,
              }
            }
          )
          var g4 = (item.price || 0).toFixed(2)
          return {
            $orig: $orig,
            l0: l0,
            g4: g4,
          }
        })
      : null
  if (!_vm._isMounted) {
    _vm.e0 = function ($event) {
      _vm.showMoney = !_vm.showMoney
    }
    _vm.e1 = function ($event) {
      _vm.showMoney = !_vm.showMoney
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        g1: g1,
        g2: g2,
        l1: l1,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }